import React, { useContext, useState } from "react";

export const ShopContext = React.createContext();

export function useShopContext(){
  return useContext(ShopContext)
}
var current = new Date();
var timeHours = current.getHours();

export function ShopProvider({ children }) {
  const [ShopCart, setShopCart] = useState([]);
  const [ShowModal, setShowModal] = useState(false);
  const [IsDragsmark, setIsDragsmark] = useState(timeHours < 12 ? false:true);

  function SetShowModal(show_modal){
    setShowModal(ShowModal => ShowModal = show_modal)
    console.log(ShopCart)
  }

  function SetIsDragsmark(){
    setIsDragsmark(IsDragsmark => !IsDragsmark);
  }

  function getShopCart(){
    return ShopCart;
  }

  const AddItem = (value) => {
    if (value == undefined){
      
      return;
    } 
    console.log("Cannot Add item",value,ShopCart)
      setShopCart(ShopCart => ShopCart.concat(value));
      console.log("Cannot Add item",ShopCart)
    
  };
  function RemoveItem(Itemid) {
    for (let i = 0; i < ShopCart.length; i++) {
      if(ShopCart[i].PinId == Itemid){
        setShopCart(ShopCart => ShopCart.filter((_, a) => a !== i));
        break;
      }
    }
  }

  function ClearItems(){
    setShopCart([])
  }

  return (
    <ShopContext.Provider value={{ ShopCart, getShopCart , AddItem, RemoveItem, ClearItems, ShowModal, SetShowModal, IsDragsmark, SetIsDragsmark }}>
      {children}
    </ShopContext.Provider>
  );
}
